import { domains, SUBSCRIPTION_ENTRY } from '@config'

// TODO remove this business rule and use contentful page reference to fulfill this rule
// every none page reference should be treated as external

export const isSubscriptionLink = (path: string): boolean =>
  Boolean(
    Object.values(SUBSCRIPTION_ENTRY).find((url) =>
      String(path).startsWith(url)
    )
  )

export const isPrivateLink = (url: string): boolean =>
  String(url).startsWith(domains.private.production)

export const isMarketLink = (url: string): boolean =>
  String(url).startsWith(domains.market.production)
